// extracted by mini-css-extract-plugin
module.exports = {"indicator__wrapper":"ColorIndicatorAtom_indicator__wrapper__NkbIz"};